export const authRoles = {
  sa: ['SA'],
  admin: ['SA', 'ADMIN'],
  editor: ['SA', 'ADMIN', 'EDITOR'],
  grantee: ['SA', 'ADMIN', 'EDITOR', 'GRANTEE'],
  guest: ['SA', 'ADMIN', 'EDITOR', 'GUEST', 'GRANTEE']
}
